import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LandingPageConfigService } from './landing-page-config.service';
import { LandingPageConfigDto } from './landing-page-config.model';

export const landingPageConfigResolver: ResolveFn<LandingPageConfigDto | null> =
  (route: ActivatedRouteSnapshot): Observable<LandingPageConfigDto | null> => {
    const service = inject(LandingPageConfigService);
    const salesOrganization = route.params['salesOrganization'];
    const language = route.params['language'];
    return service.getConfig(salesOrganization, language).pipe(
      catchError(() => of(null))
    );
  };
